import { setTransactionFiltersResponse } from '../actions';
import {
  AccountsFiltersResponse,
  getAccountsFilters,
  getMappingCodesFilter,
  getTaxRateFilters,
  MappingCodesResponse,
  TaxRatesFiltersResponse,
} from '../api';
import { FetchTransactionsFiltersAction } from '../types';
import { call, put } from 'redux-saga/effects';

export function* fetchTransactionsFiltersSaga(
  action: FetchTransactionsFiltersAction
) {
  const { provider, connectionId, mappingId } = action.payload;

  const mappingRespone: MappingCodesResponse = yield call(
    getMappingCodesFilter,
    mappingId
  );

  const accountsResponse: AccountsFiltersResponse = yield call(
    getAccountsFilters,
    connectionId
  );

    const taxRatesResponse: TaxRatesFiltersResponse = yield call(
    getTaxRateFilters,
    connectionId
  );

  let mappingCodes: any = null;
  if(mappingRespone?.data?.mappingCodes) {
    mappingCodes = mappingRespone.data.mappingCodes;
  }

  let accounts: any = null;
  if(accountsResponse?.data?.accounts) {
    accounts = accountsResponse.data.accounts;
  }

  let taxRates: any = null;
  if(taxRatesResponse?.data?.taxRates) {
    taxRates = taxRatesResponse.data.taxRates;
  }

  yield put(setTransactionFiltersResponse(provider, mappingCodes, accounts, taxRates));
}
